
















import WebPanelPage from '@sbvr/web-panel/WebPanelPage.vue';
import ContentCard from '@sbvr/components/ContentCard.vue';
import UICard from '@sbvr/ui/UICard.vue';
import game from '@/mocks/game';
import BreadcrumbNav from '@sbvr/common/legacy-shared/components/BreadcrumbNav.vue';

export default {
  name: 'ContentCardRoute',
  components: {
    WebPanelPage,
    ContentCard,
    UICard,
    BreadcrumbNav,
  },
  setup () {
    return { game };
  },
};
